import { render, staticRenderFns } from "./vehicleslist.vue?vue&type=template&id=2c53e8a8&scoped=true&"
import script from "./vehicleslist.js?vue&type=script&lang=js&"
export * from "./vehicleslist.js?vue&type=script&lang=js&"
import style0 from "./vehicleslist.vue?vue&type=style&index=0&id=2c53e8a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53e8a8",
  null
  
)

export default component.exports